<app-recipes-translation-section
  [sectionOptions]="{
    title: 'RECIPE_TRANSLATION.SECTIONS.INGREDIENTS.HEADER',
    icon: 'ic_actionable_dashboard_customize',
    lang: sortedIngredientsByType.length > 0 ? tradLang : undefined
  }"
>
  <div *ngIf="sortedIngredientsByType.length > 0; else noIngredient" class="ingredients-container">
    <app-recipes-translation-fields-container
      *ngFor="let group of sortedIngredientsByType"
      [title]="group.type | translateReferenceCode : (ingredientTypes$ | async)"
    >
      <app-recipes-translation-fields-header
        [labels]="{
          left: 'RECIPE_TRANSLATION.FIELDS_LABELS.DESCRIPTION' | translate,
          right: 'RECIPE_TRANSLATION.FIELDS_LABELS.INGREDIENT' | translate
        }"
      />

      <ng-container *ngFor="let ingredients of group.fields; last as isLast">
        <ng-container *ngFor="let ingredient of ingredients">
          <app-recipes-translation-variants [variants]="ingredient.variants" />
          <app-recipes-translation-input-fields
            [fieldsOptions]="{
              size: 'sm',
              sourceControl: ingredient.sourceControl,
              targetControl: ingredient.targetControl,
              fieldName: {
                left: 'RECIPE_TRANSLATION.FIELDS_LABELS.DESCRIPTION' | translate,
                right: 'RECIPE_TRANSLATION.FIELDS_LABELS.INGREDIENT' | translate
              }
            }"
          />
        </ng-container>
        <mat-divider *ngIf="!isLast" class="divider"></mat-divider>
      </ng-container>
    </app-recipes-translation-fields-container>
  </div>

  <ng-template #noIngredient>
    <p translate>RECIPE_TRANSLATION.SECTIONS.INGREDIENTS.NO_INGREDIENT</p>
  </ng-template>
</app-recipes-translation-section>
